<nav class="main">
    @for (item of mainItems(); track item.label) {
        @if (item.isHeader && item.children) {
            <!-- Header section -->
            <app-menu-header [label]="item.label" />
            @for (child of item.children; track child.label) {
                @if (child.children) {
                    <app-menu-group [label]="child.label" [icon]="child.icon" [children]="child.children" [testId]="child.testId" />
                } @else if (child.routerLink) {
                    <app-menu-item [label]="child.label" [icon]="child.icon" [routerLink]="child.routerLink" [testId]="child.testId" />
                }
            }
        } @else if (item.children) {
            <!-- Collapsible group -->
            <app-menu-group [label]="item.label" [icon]="item.icon" [children]="item.children" [testId]="item.testId" />
        } @else if (item.routerLink) {
            <!-- Single item -->
            <app-menu-item [label]="item.label" [icon]="item.icon" [routerLink]="item.routerLink" [testId]="item.testId" />
        }
    }
</nav>

<nav class="bottom">
    @for (item of bottomItems(); track item.label) {
        @if (item.children) {
            <app-menu-group [label]="item.label" [icon]="item.icon" [children]="item.children" [testId]="item.testId" />
        } @else if (item.routerLink) {
            <app-menu-item [label]="item.label" [icon]="item.icon" [routerLink]="item.routerLink" [testId]="item.testId" />
        }
    }
</nav>
